import { ReactNode } from "react";
import { Container } from "reactstrap";
import Header from "src/pages/components/layout/Header";
import SimpleFooter from "src/components/Footers/SimpleFooter";
import { useAppSelector } from "src/state/store/store";
type PageLayoutProps = {
  children?: ReactNode;
};
const PageLayout = ({ children }: PageLayoutProps) => {
  const auth = useAppSelector((state) => state.auth);
  const offcanvas = useAppSelector((state) => state.offcanvas);
  return (
    <>
      <div
        className={
          (auth.token != null ? "body-logged-in" : "body-logged-out") +
          " " +
          (offcanvas.isOffcanvasOpen ? "offcanvas-open" : "")
        }
      >
        <Header />
        {auth?.user?.type == "reviewer" &&
          auth?.user?.approval_status == "pending" && <UnverifiedWarning />}

        {children}
        <SimpleFooter />
      </div>
    </>
  );
};
export default PageLayout;

const UnverifiedWarning = () => {
  return (
    <div
      className="alert alert-warning"
      style={{ borderRadius: 0, textAlign: "center", margin: 0 }}
    >
      {" "}
      <strong>Verification Pending!</strong> Please get your account verified by
      submitting profile and required documents.
    </div>
  );
};
